// extracted by mini-css-extract-plugin
module.exports = {"wavesGrid":"waves_wavesGrid__3LZ3F","waveContainer":"waves_waveContainer__Z9rHK","wave":"waves_wave__YGt8N","bubbles":"waves_bubbles__2czik","bubble":"waves_bubble__2ZMUy"};